import { CommonModule } from '@angular/common';
import { AuthService, FrameworkNgxModule } from '@kpd/framework-ngx';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { TableModule } from 'primeng/table';
import { RoleService } from 'app/shared/services/role.service';
import { LicenseService } from 'app/shared/services/license.service';
import { ApplicationService } from 'app/shared/services/application.service';
import { RefreshActionComponent } from 'app/shared/components/actions/refresh-action.component';
import { TenantService } from './services/tenant.service';
import { LicenseCardComponent } from 'app/shared/components/license-card/license-card.component';
import { ChangePasswordDialogComponent } from './components/dialogs/change-password-dialog.component';
import { ChangePasswordComponent } from 'app/shared/components/change-password/change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LinkEntitiesComponent } from 'app/shared/components/link-entities/link-entities.component';
import { PermissionsetService } from 'app/shared/services/permissionset.service';
import { ChangePasswordFormgroupComponent } from 'app/shared/components/change-password/change-password-formgroup.component';
import { UserTypeService } from 'app/shared/services/user-type.service';
import { TenantsMenuItemComponent } from './tenants-menu-item/tenants-menu-item.component';
import { NgModule } from '@angular/core';
import { LargeAlertComponent } from './components/dialogs/alert-dialog-large.component';
import { GotoRedirectComponent } from './components/actions/goto-redirect.component';

@NgModule({
  declarations: [
    ChangePasswordDialogComponent,
    ChangePasswordFormgroupComponent,
    RefreshActionComponent,
    LicenseCardComponent,
    ChangePasswordComponent,
    LinkEntitiesComponent,
    TenantsMenuItemComponent,
    LargeAlertComponent,
    GotoRedirectComponent,
  ],
  imports: [
    CommonModule,
    FrameworkNgxModule,
    TranslateModule,
    ConfirmDialogModule,
    DialogModule,
    TableModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    // KPD Framework
    FrameworkNgxModule,

    // 3th party
    TranslateModule,
    // PrimeNG
    ConfirmDialogModule,
    DialogModule,
    // Components
    ChangePasswordDialogComponent,
    ChangePasswordFormgroupComponent,
    RefreshActionComponent,
    LicenseCardComponent,
    LinkEntitiesComponent,
    TenantsMenuItemComponent,
    // Directives
    ChangePasswordComponent,
    LargeAlertComponent,
    GotoRedirectComponent,
  ],
  providers: [
    AuthService,
    RoleService,
    LicenseService,
    TenantService,
    ApplicationService,
    PermissionsetService,
    UserTypeService,
  ],
})
export class SharedModule {}
